import Vue from 'vue';
import Router from 'vue-router';
// import Insight from './pages/insight/Insight.vue'
import Home from './pages/home/home.vue'
import Privacy from './pages/privacy/privacy.vue'
import ClientTerms from './pages/client_terms/client_terms.vue'
import Articles from './pages/articles/articles.vue'

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    { path: '/', name: 'home', component: Home, },
    // { path: '/insight', name: 'insight', component: Insight, },
    { path: '/clients', redirect: () => { window.location.href = 'https://clients-ai.com' }},
    { path: '/privacy', name: 'privacy', component: Privacy, },
    { path: '/clientterms', name: 'clientterms', component: ClientTerms, },
    { path: '/articles', name: 'articles', component: Articles, },
    { path: '/contact', name: 'contact',
      component: () => import(/* webpackChunkName: "contact" */ './pages/contact/contact.vue')
    },
  ],
});
